'use strict';

import {siteConfig} from '../siteConfig';
module.exports = function (Authentication, $state, $timeout, $q, $rootScope) {
    var _this = this;
    this.siteConfig = siteConfig;
    this.Authentication = Authentication;
    this.loadingProgress = 'LOGIN.PROGRESS.LOADING_PROFILE';
    this.loggingOut = false;

    this.logOut = () => {
        if (_this.loggingOut) {
            return;
        }
        _this.loggingOut = true;
        $rootScope.isLoggingOut = true;
        _this.loadingProgress = 'DASHBOARD.LOGGING_OUT';
        const minDelay = $timeout(angular.noop, 1500);
        const logoutPromise = Authentication.logOut().catch(() => {});
        return $q.all([logoutPromise, minDelay]).then(() => {
            $rootScope.isLoggingOut = false;
            return $state.go('login');
        });
    };

    this.redirectAfterLoad = (departments) => {
        if (_this.loggingOut) {
            return;
        }
        _this.loadingProgress = 'LOGIN.PROGRESS.REDIRECTING';
        if (Authentication.isAuthorized("viewer") && siteConfig.viewerToWebapp != undefined) {
            const fromBuilder = {
                id: window.localStorage.$LoopBack$accessTokenId,
                user: Authentication.currentUserInfo().user || Authentication.currentUserInfo(),
            };
            const fromBuilderB64 = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(fromBuilder))));
            window.location.replace(siteConfig.webapp[siteConfig.viewerToWebapp].url.concat("/fromBuilder#", fromBuilderB64));
            return;
        }
        if (Authentication.isAuthorized("viewer")) {
            let deptId = localStorage.getItem('lastDepartment');
            let departmentExists = departments && departments.find(dept => dept.id == deptId);
            let targetDeptId = departmentExists ? deptId : departments[0].id;
            return $state.go('dashboard.departments.department.forms', {
                departmentId: targetDeptId
            });
        }
        if (_this.siteConfig?.tags?.includes('certdigital') && Authentication.isAuthorized(['owner', 'supervisor'])) {
            return $state.go('dashboard.validations');
        }
        if (Authentication.isAuthorized('supervisor')) {
            return $state.go('dashboard.validations');
        }
        if (!departments || !departments.length) {
            return;
        }
        let deptId = localStorage.getItem('lastDepartment');
        let departmentExists = departments.find(dept => dept.id == deptId);
        let targetDeptId = departmentExists ? deptId : departments[0].id;
        return $state.go('dashboard.departments.department', {
            departmentId: targetDeptId
        });
    };

    this.bootstrapSession = () => {
        _this.loadingProgress = 'LOGIN.PROGRESS.LOADING_PROFILE';
        Authentication.resolveUser(true)
            .then(() => {
                if (_this.loggingOut) {
                    return;
                }
                _this.loadingProgress = 'LOGIN.PROGRESS.VERIFYING_PERMISSIONS';
                return Authentication.loadRoles();
            })
            .then(() => {
                if (_this.loggingOut) {
                    return;
                }
                _this.loadingProgress = 'LOGIN.PROGRESS.LOADING_DEPARTMENTS';
                return Authentication.loadDepartments(true);
            })
            .then((departments) => {
                if (_this.loggingOut || departments === undefined) {
                    return;
                }
                $timeout(() => {
                    _this.redirectAfterLoad(departments);
                }, 300);
            })
            .catch(() => {
                if (_this.loggingOut) {
                    return;
                }
                Authentication.logOut()
                    .then(() => $state.go('login'))
                    .catch(() => $state.go('login'));
            });
    };

    this.bootstrapSession();
};
